module.exports = __webpack_public_path__ + "img/luxembourg.ec99c104.png";